<template>
  <div id="jiaotongsheshifenbu"></div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'JiaoTongSheshiFenbu',
  components: {},
  props: {
    colorList: {
      type: Array
    },
    mapData: {
      type: Object
    }
  },
  data() {
    return {
      map: null
    }
  },
  mounted() {
    this.map = new AMap.Map('jiaotongsheshifenbu', {
      mapStyle: 'amap://styles/5411bd4e683c3b6f54012fe05ad53f5a'
    })

    // 遍历增加标记
    for (let i = 0; i < this.mapData.pointData.length; i++) {
      for (let j = 0; j < this.mapData.pointData[i].data.length; j++) {
        // 创建纯文本标记
        var text = new AMap.Text({
          text: this.mapData.pointData[i].data[j].name,
          anchor: 'center',
          cursor: 'pointer',
          style: {
            borderRadius: '5px',
            backgroundColor: this.colorList[i],
            opacity: '0.8',
            width: this.mapData.pointData[i].data[j].name.length * 16 + 'px',
            height: '20px',
            lineHeight: '16px',
            textAlign: 'center',
            color: '#111',
            border: 'none'
          },
          position: this.mapData.pointData[i].data[j].position
        })
        // 推入地图
        text.setMap(this.map)

        // 创建一个 icon
        var endIcon = new AMap.Icon({
          size: new AMap.Size(70, 30),
          image: this.mapData.pointData[i].icon,
          imageSize: new AMap.Size(70, 30)
        })

        // 将 icon 传入 marker
        var endMarker = new AMap.Marker({
          position: new AMap.LngLat(
            this.mapData.pointData[i].data[j].position[0],
            this.mapData.pointData[i].data[j].position[1]
          ),
          icon: endIcon,
          offset: new AMap.Pixel(-35, -50)
        })

        // 将 markers 添加到地图
        this.map.add([endMarker])
      }
    }
    this.map.setFitView()
  },
  methods: {}
}
</script>

<style scoped lang="less">
#jiaotongsheshifenbu {
  width: 100%;
  height: 100%;
}
</style>
